import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import PropTypes from 'prop-types'

import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'

import NextButton from './next-button'
import PreviousButton from './previous-button'

const isAuth = (url) => url.includes('AUTH')

const isLast = (menu_json, index) => index === menu_json.length - 1

const isFirst = index => index === 0

const format = (url) => isAuth(url) ? url.replace('AUTH', '') : url

// Returns index of current page in menu_json Array
const getCurrentUrlIndex = (pathname, menu_json) => {
  for (let i = 0; i < menu_json.length; i++) {
    if (
      pathname === menu_json[i] ||
      pathname.slice(0, -1) === menu_json[i] || // Check if pathname ends with '/'
      `AUTH${pathname}` === menu_json[i] ||
      `AUTH${pathname.slice(0, -1)}` === menu_json[i] // Check if pathname ends with '/'
    ) {
      return i
    }
  }
}

// Returns first index url value that does not contain AUTH, or returns undefined if end of list is reached
const findNextNonAuthUrl = (menu_json, index) => {
  for (let i = index; i < menu_json.length; i++) {
    if (!isAuth(menu_json[i])) {
      return menu_json[i]
    }
  }

  return undefined
}

  // Returns first index url value that does not contain AUTH, or returns undefined if beginning of list is reached
const findPreviousNonAuthUrl = (menu_json, index) => {
  for (let i = index; i >= 0; i--) {
    if (!isAuth(menu_json[i])) {
      return menu_json[i]
    }
  }

  return undefined
}

const getNextValidUrl = (is_authenticated, menu_json, index) => {
  let is_last = isLast(menu_json, index)
  if (is_last) {
    return undefined
  }

  return is_authenticated
    ? format(menu_json[index + 1])
    : findNextNonAuthUrl(menu_json, index + 1)
}

const getPreviousValidUrl = (is_authenticated, menu_json, index) => {
  let is_first = isFirst(index)
  if (is_first) {
    return undefined
  }

  return is_authenticated
    ? format(menu_json[index - 1])
    : findPreviousNonAuthUrl(menu_json, index - 1)
}

const next = (is_authenticated, pathname, menu_json) => {
  let current_url_index = getCurrentUrlIndex(pathname, menu_json)

  return getNextValidUrl(is_authenticated, menu_json, current_url_index)
}

const previous = (is_authenticated, pathname, menu_json) => {
  let current_url_index = getCurrentUrlIndex(pathname, menu_json)

  return getPreviousValidUrl(is_authenticated, menu_json, current_url_index)
}

export default function NextPreviousRow(props) {
  const data = useStaticQuery(graphql`
    query {
      allDataJson {
        edges {
          node {
            urls
          }
        }
      }
    }
  `)

  return (
    <Row className="mb-4" style={{"flex": "1"}}>
      <Col className="d-flex align-items-end">
        <PreviousButton
          previous={previous(props.authenticated, props.location.pathname, data.allDataJson.edges[0].node.urls)}
        />
        <NextButton
          next={next(props.authenticated, props.location.pathname, data.allDataJson.edges[0].node.urls)}
        />
      </Col>
    </Row>
  )
}

NextPreviousRow.propTypes = {
  location: PropTypes.object.isRequired,
  authenticated: PropTypes.bool.isRequired
}

export {
  isAuth,
  isFirst,
  isLast,
  format,
  getCurrentUrlIndex,
  findNextNonAuthUrl,
  findPreviousNonAuthUrl,
  getNextValidUrl,
  getPreviousValidUrl,
  next,
  previous
}